import admin from '@olo-web/utils/google/firebase/admin';
import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

export const setAdmin = async (body: ISetAdminRequestBody): Promise<admin.auth.GetUsersResult> => {
  try {
    const url = `/api/users/set-admin`;
    const { data } = await axios.post(url, body);
    return data;
  } catch (error) {
    console.error(error);
    throw new Error(error?.response?.data?.message || error?.response?.data?.error || error);
  }
};

export const useSetAdmin = (
  options?: UseMutationOptions<admin.auth.GetUsersResult, AxiosError, ISetAdminRequestBody>
) => {
  return useMutation(setAdmin, options);
};
